import {EcommerceVariant} from '../interfaces/shopify-product.interface';

export class ShoppingCartUtils {
  static getStoredShoppingCart(checkoutId: string): string {
    return window.localStorage.getItem(checkoutId);
  }

  static deleteStoredShoppingCart(checkoutId: string) {
    window.localStorage.removeItem(checkoutId);
  }

  static isMatchingVariant(
    selectedOptions: Pick<EcommerceVariant, 'option1' | 'option2' | 'option3'>,
    variant: EcommerceVariant
  ): boolean {
    return selectedOptions.option1 === variant.option1 &&
      selectedOptions.option2 === variant.option2 &&
      selectedOptions.option3 === variant.option3;
  }
}
